<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="mx-auto">
        <template slot-scope="{toggle, isToggled}">
            <router-link v-popover:popover1 class="navbar-brand" to="/">
                <img src="img/sarel/JHOPFAN-icon-with-text.svg">
            </router-link>
        </template>
        <template slot="navbar-menu">
            <!-- <li class="nav-item">
                <a class="nav-link"
                   href="/auditorium">
                    <p>Main Auditorium</p>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   href="/tracks">
                    <p>Tracks</p>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   href="/prayer">
                    <p>24/7 Prayer</p>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   href="/resources">
                    <p>Resources</p>
                </a>
            </li> -->
            <li v-if="isVideosRoute" class="nav-item">
                <a class="nav-link not-btn" :href="constTxts.golbal_prayer_link_path" target="_blank">
                    <p>Live Global Prayer</p>
                </a>
            </li>
            <li v-if="!this.isLoggedUser" class="nav-item">
                <a class="nav-link btn btn-primary"
                   href="/signin">
                    <p>Sign in</p>
                </a>
            </li>
            <li v-if="this.isLoggedUser" class="nav-item">
                <a class="nav-link btn btn-primary"
                   @click="doLogout" href="/">
                    <p>Sign out</p>
                </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link btn btn-primary"
                   href="/signup">
                    <p>Signup</p>
                </a>
            </li> -->

        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'

  import { mapGetters } from 'vuex'
  import {texts} from '@/constants/texts'

  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },
    computed: {
        ...mapGetters(['isLoggedUser']),
        constTxts() { return texts },
        isVideosRoute() {
            return this.$route.name === 'videos'
        }
    },
    methods: {
      doLogout(e) {
          e.preventDefault()
          this.$store.dispatch('logout')
      }
    }
  }
</script>

<style scoped>
.navbar-brand img {
    height: 30px;
}

</style>
